'use client';
import Image from 'next/image';

const speakers = [
  {
      name: "Mustafa Abdulrazzaq",
      designation: "CEO",
      company: "MediVail",
      imageSrc: "/images/speakers/mustafa-abdulrazzaq-pic.webp",
      alt: "mustafa-abdulrazzaq",
    },
    {
      name: "Andrey	Perfilyev",
      designation: "CEO & Co-founder",
      company: "Yma Health",
      imageSrc: "/images/speakers/andrey-perfilyev.webp",
      alt: "andrey-perfilyev",
    },
    {
      name: "Roman Smagulov",
      designation: "CEO & Co-founder",
      company: "Alpine Diagnostics",
      imageSrc: "/images/speakers/roman-smagulov.webp",
      alt: "roman-smagulov",
    },
    {
      name: "Dr. Marino Sabijan",
      designation: "Founder",
      company: "OmegaX Health",
      imageSrc: "/images/speakers/dr-marino-sabijan.webp",
      alt: "dr-marino-sabijan",
    },
  
    {
      name: "Dr Dominique Eggermont MD MBA",
      designation: "CEO",
      company: "WITiMediX",
      imageSrc: "/images/speakers/dr-dominique.webp",
      alt: "dr-dominique-eggermont",
    },
    {
      name: "tasneem-taherali",
      designation: " Advisor for Tech Startups and Scale ups | Marketing Director for Women in Tech UAE",
      company: "Ambassador Product Marketing Alliance UAE",
      imageSrc: "/images/speakers/tasneem-taherali.webp",
      alt: "tasneem-taherali",
    },
  // end of 2025 speakers
  {
    name: "Dr. Adam Chee",
    designation: "Founding Lead",
    company: "Centre for AI-Enabled Health (CAIEH)",
    imageSrc: "/images/speakers/dr-adam.webp",
    alt: "dr-adam-chee",
  },
  {
    name: "Pauline Erica Tay",
    designation: "Director",
    company: "National Health Innovation Centre",
    imageSrc: "/images/speakers/pauline-erica.webp",
    alt: "pauline-erica",
  },
  {
    name: "Lawrence Wee",
    designation: "Associate Faculty",
    company: "Singapore University of Social Sciences",
    imageSrc: "/images/speakers/lawrence-wee.webp",
    alt: "lawrence-wee",
  },
  {
    name: "Ethan Seow",
    designation: "CEO and co-founder",
    company: "Centre for AI Leadership (C4AIL)",
    imageSrc: "/images/speakers/ethan.webp",
    alt: "ethan",
  },
  
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.tsx:82:4" data-component-path="src/app/SpeakerSection.tsx" data-component-line="82" data-component-end-line="119" data-component-file="SpeakerSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20px-4%20py-12%20flex%20flex-col%20items-center%20justify-center%20bg-%5B%23f5f5f5%5D%22%7D" id='speakers'
      className="w-full px-4 py-12 flex flex-col items-center justify-center bg-[#f5f5f5]"
    >
      <div data-component-id="src/app/SpeakerSection.tsx:85:6" data-component-path="src/app/SpeakerSection.tsx" data-component-line="85" data-component-end-line="118" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1270px%5D%22%7D" className="w-full max-w-[1270px]">
        {/* Section Title */}
        <h2 data-component-id="src/app/SpeakerSection.tsx:87:8" data-component-path="src/app/SpeakerSection.tsx" data-component-line="87" data-component-end-line="89" data-component-file="SpeakerSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-center%20text-%5B28px%5D%20sm%3Atext-%5B36px%5D%20lg%3Atext-%5B48px%5D%20font-semibold%20text-%5B%231d1d1d%5D%20leading-snug%20mb-8%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-center text-[28px] sm:text-[36px] lg:text-[48px] font-semibold text-[#1d1d1d] leading-snug mb-8">
          Past Speakers
        </h2>

        {/* Speaker Grid */}
        <div data-component-id="src/app/SpeakerSection.tsx:92:8" data-component-path="src/app/SpeakerSection.tsx" data-component-line="92" data-component-end-line="117" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-8%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 place-items-center">
          {speakers.map((speaker, index) => (
            <div data-component-id="src/app/SpeakerSection.tsx:94:12" data-component-path="src/app/SpeakerSection.tsx" data-component-line="94" data-component-end-line="115" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20text-center%22%7D" key={index} className="flex flex-col items-center text-center">
              {/* Circle Image */}
              <Image data-component-id="src/app/SpeakerSection.tsx:96:14" data-component-path="src/app/SpeakerSection.tsx" data-component-line="96" data-component-end-line="103" data-component-file="SpeakerSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-%5B300px%5D%20h-%5B200px%5D%20object-cover%20w-%5B200px%5D%20sm%3Aw-%5B290px%5D%20sm%3Ah-%5B290px%5D%22%7D"
                src={speaker.imageSrc}
                alt={speaker.alt}
                width={160}
                height={160}
                className="rounded-[300px] h-[200px] object-cover w-[200px] sm:w-[290px] sm:h-[290px]"
                unoptimized
              />

              {/* Text */}
              <h3 data-component-id="src/app/SpeakerSection.tsx:106:14" data-component-path="src/app/SpeakerSection.tsx" data-component-line="106" data-component-end-line="108" data-component-file="SpeakerSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%232eb6ca%5D%20text-%5B16px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20mt-3%22%7D" className="text-[#2eb6ca] text-[16px] sm:text-[18px] font-semibold mt-3">
                {speaker.name}
              </h3>
              <p data-component-id="src/app/SpeakerSection.tsx:109:14" data-component-path="src/app/SpeakerSection.tsx" data-component-line="109" data-component-end-line="111" data-component-file="SpeakerSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-black%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%22%7D" className="text-black text-[12px] sm:text-[14px]">
                {speaker.designation}
              </p>
              <p data-component-id="src/app/SpeakerSection.tsx:112:14" data-component-path="src/app/SpeakerSection.tsx" data-component-line="112" data-component-end-line="114" data-component-file="SpeakerSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-black%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%22%7D" className="text-black text-[12px] sm:text-[14px]">
                {speaker.company}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
